import { BoundedContent, Box, H2 } from '@vp/swan';
import { SupportedLocale, __ } from '@99designs/i18n';
import { usePage } from '@99designs/tracking';
import { DesignProductPresenter } from '../../../products/';
import { getNavigationData } from '../../../products/tracking';
import { ProductCarousel } from '../ProductCarousel';

interface PopularProductsProps {
    products: DesignProductPresenter[];
    locale: SupportedLocale;
    title?: string;
}

export function PopularProducts({
    products,
    locale,
    title = __('Popular Products'),
}: PopularProductsProps) {
    const { pageData } = usePage();

    return (
        <BoundedContent>
            <Box paddingLeft={{ xs: 3, md: 0 }} paddingRight={{ xs: 3, md: 0 }}>
                <H2 marginBottom="6">{title}</H2>
                <ProductCarousel
                    products={products}
                    locale={locale}
                    productClickedTrackingData={(product, index) => {
                        return getNavigationData(product, {
                            pageName: pageData.pageName,
                            pageStage: pageData.pageStage,
                            pageSection: pageData.pageSection,
                            pagePath: pageData.pagePath ?? window.location.pathname,
                            pageZone: 'Popular Product Tiles',
                            position: index,
                        });
                    }}
                />
            </Box>
        </BoundedContent>
    );
}
